import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import Header from '../../../../components/Header/Header';

const PLACEHOLDER = 'Draft your offer message';
const MESSAGE_MAX_LENGTH = 250;

const block = 'tq-help-offer-form';

interface HelpOfferMessageEditorProps {
  initialMessage: string;
  onDone: (message: string) => void;
  onClose: () => void;
}

const HelpOfferMessageEditor: React.FC<HelpOfferMessageEditorProps> = ({
  initialMessage,
  onDone,
  onClose,
}) => {
  const [message, setMessage] = useState(initialMessage);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!initialMessage || !textareaRef.current) return;
    const el = textareaRef.current;
    const len = initialMessage.length;
    const id = requestAnimationFrame(() => {
      el.setSelectionRange(len, len);
    });
    return () => cancelAnimationFrame(id);
  }, [initialMessage]);

  const isDoneActive = message.trim().length > 0;

  const handleDone = () => {
    onDone(message);
  };

  return (
    <div className={`${block} ${block}--editor page__container`}>
      <Header
        title="How You Can Offer Help"
        handleBack={onClose}
        customHeaderClass={`${block}__header`}
        backType="cross"
        actionItems={[
          <button
            key="done"
            type="button"
            className={`${block}__header-done ${
              isDoneActive ? `${block}__header-done--active` : ''
            }`}
            disabled={!isDoneActive}
            onClick={handleDone}>
            Done
          </button>,
        ]}
      />
      <div className={`${block}__editor-content`}>
        <textarea
          ref={textareaRef}
          className={`${block}__editor-textarea`}
          placeholder={PLACEHOLDER}
          value={message}
          onChange={(e) =>
            setMessage(e.target.value.slice(0, MESSAGE_MAX_LENGTH))
          }
          maxLength={MESSAGE_MAX_LENGTH}
          autoFocus
        />
        <div
          className={`${block}__char-count ${
            message.length >= MESSAGE_MAX_LENGTH - 10
              ? `${block}__char-count--near-limit`
              : message.length > 0
                ? `${block}__char-count--active`
                : ''
          }`}>
          {message.length}/{MESSAGE_MAX_LENGTH}
        </div>
      </div>
      <div className={`${block}__editor-keyboard-spacer`} />
    </div>
  );
};

export default HelpOfferMessageEditor;
